import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { PollListScreen, CreatePollScreen, ManagePollSectionsScreen, PollDetailsScreen, EditPollScreen, SurveyResultsScreen, PollResultsScreen, PollParticipantListScreen } from './../../screens';
import { MenuAction } from '../shared/sidebar.menu';
import { HeaderLogo } from '../shared/header.logo';
import { View } from 'react-native';
import { Button } from '../../components/_primatives';


const Stack = createStackNavigator();

export const PollStack = ({ navigation, route }) => {
    console.log('export const SurveyStack = ({ navigation, route }) => {', {navigation, route});
    navigation.setOptions({ tabBarVisible: false });
    if (route.state) {
        navigation.setOptions({ tabBarVisible: route.state.index === 0 });
    }
    return (
        <Stack.Navigator initialRouteName='All'>
            <Stack.Screen
                name='All'
                component={PollListScreen}
                options={{
                    // headerTitleAlign: 'center',
                    headerLeft: () => <MenuAction />,
                    // headerTitle: () => <HeaderLogo />,
                    headerTitle: ''
                }}
            />
            <Stack.Screen name='Poll' component={PollDetailsScreen} options={{ title: 'Poll Details' }} />
            <Stack.Screen name='CreatePoll' component={CreatePollScreen} options={{ title: 'Create Poll', headerStyle: { shadowOpacity: 0, elevation: 0 } }} />
            <Stack.Screen name='EditPoll' component={EditPollScreen} options={{ title: 'Edit Poll' }} />
            <Stack.Screen name='ManagePoll' component={ManagePollSectionsScreen} options={{ title: 'Edit Poll' }} />
            <Stack.Screen name='PollResults' component={PollResultsScreen} options={{ title: 'Poll Results' }} />
            <Stack.Screen name='PollParticipantList' component={PollParticipantListScreen} options={{ title: 'Poll Participants' }} />
            {/* <Stack.Screen name='SurveyQuestionResponseList' component={SurveyQuestionResponseListScreen} options={{ title: 'Question Responses' }} /> */}
        </Stack.Navigator>
    )
};